import React from "react";
import { ArrowRight } from "lucide-react";
import { pushGtmEvent } from "@/lib/gtm";
import { waLink, LP_WA_MESSAGE } from "./lpData";

// Every LP CTA opens WhatsApp and reports its section to GTM
const LpCta = ({ children, location, message = LP_WA_MESSAGE, className = "" }) => (
  <a
    href={waLink(message)}
    target="_blank"
    rel="noreferrer"
    className={`btn-lp-green ${className}`}
    data-testid={`lp-cta-${location}`}
    onClick={() => pushGtmEvent("whatsapp_click", { location: `lp_${location}` })}
  >
    {children}
    <ArrowRight size={16} />
  </a>
);

export default LpCta;
